import ElementController from "../base-controllers/ElementController.js";
/** Keep a displayed total in sync with number inputs as the user types. */
class SumInputs extends ElementController {
    constructor() {
        super(...arguments);
        this.update = () => {
            const total = Array.from(this.root.querySelectorAll("[data-sum-input]")).reduce((sum, input) => {
                const value = input.valueAsNumber;
                return sum + (Number.isFinite(value) ? Math.max(value, 0) : 0);
            }, 0);
            const output = this.root.querySelector("[data-sum-output]");
            if (output)
                output.textContent = String(total);
        };
    }
}
SumInputs.id = "SumInputs";
SumInputs.binds = {
    "[data-sum-input]": [["input", "update"]],
    global: [
        ["form:formsetFormAdded", "update"],
        ["form:formsetFormRemoved", "update"],
    ],
};
export default SumInputs;
//# sourceMappingURL=SumInputs.js.map